import { SCATTER_PLOT_APP_STATE_SLICE_KEY, SCATTER_PLOT_STATE_KEYS } from '../state/constants';
import { AppStateService } from 'NewAngular/services/app-state.service';
import { AppStateManager } from 'NewAngular/services/app-state-manager.service';
import { ScatterPlotUrlDeserializer } from 'ChartApp/ts/apps/scatter-plot/scatter-plot.serializers';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/app-state.service";
export class ScatterPlotAppStateManager extends AppStateManager {
    constructor(appStateService) {
        super(appStateService);
        this.appStateService = appStateService;
    }
    initAppState() {
        this.appStateService.setStateSlice(SCATTER_PLOT_APP_STATE_SLICE_KEY);
        this.appStateService.setUrlParamKeys(SCATTER_PLOT_STATE_KEYS);
        this.appStateService.setCustomUrlParamDeserializer(ScatterPlotUrlDeserializer);
        this.appStateService.start();
    }
}
ScatterPlotAppStateManager.ɵfac = function ScatterPlotAppStateManager_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotAppStateManager)(i0.ɵɵinject(i1.AppStateService)); };
ScatterPlotAppStateManager.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ScatterPlotAppStateManager, factory: ScatterPlotAppStateManager.ɵfac, providedIn: 'root' });
